module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pl-dialog', {
    attrs: {
      "title": "Sync Assessment",
      "size": 'sm',
      "disableOutsideClick": true
    },
    on: {
      "close": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [(_vm.isLoading === true) ? _c('div', {
    staticClass: "flex justify-center my-24"
  }, [_c('pl-spinner', {
    staticClass: "w-12 h-12"
  })], 1) : _vm._e(), _vm._v(" "), (
    !_vm.integrationToSyncAssessment &&
    _vm.isLoading === false &&
    _vm.currentActivity.google_classroom_course_work_id === null
  ) ? _c('div', {
    staticClass: "py-5 flex-grow overflow-y-auto my-4"
  }, [_c('div', {
    staticClass: "flex justify-center mb-4"
  }, [_c('div', {
    staticClass: "bg-gray-100 p-4 rounded-full border border-solid border-gray-200"
  }, [_c('i', {
    staticClass: "fa-solid fa-chalkboard-user text-primary text-2xl"
  })])]), _vm._v(" "), _c('h6', {
    staticClass: "text-center text-gray-700 text-lg font-semibold mb-3"
  }, [_vm._v("\n      Would you like to sync grades?\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "px-28 mb-12 text-center"
  }, [_c('span', {
    staticClass: "text-center text-gray-700"
  }, [_vm._v("\n        Heads up, you must connect this\n        "), _c('span', {
    staticClass: "font-semibold"
  }, [_vm._v("Parlay Course")]), _vm._v(" to a class in your\n        LMS, and then connect this\n        "), _c('span', {
    staticClass: "font-semibold"
  }, [_vm._v("RoundTable to an assignment in your LMS")]), _vm._v("\n        before you can sync assessment data between the two systems.\n      ")])])]) : _c('div', [(_vm.currentActivity.google_classroom_course_work_id) ? _c('div', [_c('IntegrationCard', {
    attrs: {
      "title": 'Google Classroom',
      "icon": '/static/google_class_round.png',
      "code": 'google-classroom',
      "sync": true,
      "memberships": _vm.memberships
    }
  })], 1) : _vm._e()]), _vm._v(" "), (
    !_vm.integrationToSyncAssessment &&
    _vm.isLoading === false &&
    _vm.currentActivity.google_classroom_course_work_id === null
  ) ? _c('div', {
    staticClass: "flex center justify-center my-7"
  }, [(
    _vm.getCourseDetail.edlink_integrations.length === 0 &&
    _vm.getCourseDetail.google_classroom_integration.course_id === undefined
  ) ? _c('button', {
    staticClass: "bg-primary text-white px-6 py-2 rounded",
    on: {
      "click": _vm.pushToCourseIntegrations
    }
  }, [_vm._v("\n      Connect Course\n    ")]) : _c('button', {
    staticClass: "bg-primary text-white px-6 py-2 rounded",
    on: {
      "click": function($event) {
        _vm.$emit('goToInviteStudents'), _vm.$emit('close')
      }
    }
  }, [_vm._v("\n      Connect RoundTable\n    ")])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-16ba08ae!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/modals/connectIntegrationsAssessmentModal.vue
// module id = 1020
// module chunks = 61